export default "__VITE_ASSET__48da9712__"